// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3S9yp","box":"WorkspacesBox_box__3Nqaq","node":"WorkspacesBox_node__2BsSq"};